import React from 'react'
import './BusinessCard.css';
import SearchBar, {handleSubmit} from '../search/SearchBar'

function BusinessCard(props) {
    const { results } = props;

    return (
        <div>
            {results.map((result) => (
                <div key={result.id} className='businessContainer'>
                    <div>
                        <img className="businessContainer image" src={result.image_url} alt={result.name} />
                    </div>
                    <div className="businessContainer title">{result.name}</div>

                    <div className="businessContainer wrapper">
                        <div className="businessContainer contact">
                            <div>{result.address}</div>
                            <div>{result.city}</div>
                            <div>{result.state}</div>
                            <div>{result.zipCode}</div>
                        </div>
                        <div className="businessContainer info">
                            <div>{result.category}</div>
                            <div>{result.rating} stars</div>
                            <div>{result.reviewCount} reviews</div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default BusinessCard;
